import React, { useState, useEffect } from "react";
import { Container, Row, Col, Button, Form, ButtonGroup } from "react-bootstrap";
import AlertComponent from "../alerts/AlertComponent";
import SectionsTable from "./SectionsTable";
import Switch from 'react-switch'
import SectionModel from "./SectionModal";
import FeeModal from "../../fees/FeeModal";
import { getUsers, getCategories, getDesignatedDepartments, getSections, getTags, getDepartmentPermissions } from "../../utils/api";
import { GetSelected, SetSelectedDepartment, SetSelectedCategory } from "../../utils/DesignatedDepartments";
import { ColoredLine } from "../elements/ColoredLine";
import { checkUserToken } from "../../utils/checkUser";
import Select from 'react-select';
import makeAnimated from 'react-select/animated';

const animatedComponents = makeAnimated();
const Sections = () => {
  const [openNewModal, setOpenNewModal] = useState(false);
  const [openFeeModal, setOpenFeeModal] = useState(false);
  const [sectionCreated, setSectionCreated] = useState(false);
  const [sectionUpdated, setSectionUpdated] = useState(false);
  const [sectionError, setSectionError] = useState(false);
  const [users, setUsers] = useState([]);

  const [categories, setCategories] = useState([])
  const [tags, setTags] = useState([]);

  const [designatedDepartments, setDesignatedDepartments] = useState([]);
  const [chosenDepartment, setChosenDepartment] = useState("")
  const [sections, setSections] = useState([]);
  const [sectionsVisible, setSectionsVisible] = useState([]);
  const [sectionID, setSectionID] = useState("All")

  const [searchText, setSearchText] = useState("");

  const [chosenCategory, setChosenCategory] = useState("All");

  const [categoryHighlight, setCategoryHighlight] = useState("")

  const [update, setUpdate] = useState(false);

  const [permission, setPermission] = useState(false);
  const {selected} = GetSelected();

  useEffect(() => {
    getDesignatedDepartments(setDesignatedDepartments);
    getUsers(setUsers);
    checkUserToken();
  }, []);

  useEffect (() => {
    if (chosenDepartment !== "" && chosenDepartment !== undefined) {
      getSections(setSections, chosenDepartment, chosenCategory);
      getCategories(setCategories, chosenDepartment);
      getTags(setTags, chosenDepartment);
      getDepartmentPermissions(setPermission, chosenDepartment);
      setChosenCategory("All")
    }
  }, [chosenDepartment])

  useEffect(() => {
    if (chosenDepartment !== "" && chosenDepartment !== undefined) {
      getSections(setSections, chosenDepartment, chosenCategory);
    } 
  }, [chosenCategory])

  /* Gets the selected department */
  useEffect(() => {
    if (selected.department === "" && designatedDepartments[0] !== undefined) {
      setChosenDepartment(designatedDepartments[0].value);
    } else {
      setChosenDepartment(selected.department);
    }
    setChosenCategory(selected.category);
  },[designatedDepartments])

/***********************/
/* Method for filtering sections */


//Filter Level 2
useEffect(() => {
    setSectionsVisible(
      sections.filter((section) => {
        const tags = section.tags.toString();
        return (
          section.name.toLowerCase().includes(searchText.toLowerCase()) ||
          section.description.toLowerCase().includes(searchText.toLowerCase()) ||
          tags.toLowerCase().includes(searchText.toLowerCase()) ||
          section._id.toLowerCase().includes(searchText.toLowerCase())  
        );
      })
    ); 
  }, [searchText, sections]);

  return (
    <Container className="section-container" fluid>
      {sectionCreated && <AlertComponent type="success" text="Section Created!" />}
      {sectionUpdated && <AlertComponent type="primary" text="Section Updated!" />}
      {sectionError && <AlertComponent type="danger" text="You do not have permission to perform this action." />}

      <Row className="header-row">
          <Col>
              <h2 className="page-header">Sections</h2>
          </Col>
          <Col className="col-new-section" lg={5} sm={7} xs={9}> 
            <Container className="section-buttons">           
                <Button className="pull-right primary-button border-button section-button" onClick={() => {setOpenNewModal(true); setSectionID("")}}>
                  + New Section
                </Button>
      
                <Button className="pull-right primary-button border-button fee-button" onClick={() => {setOpenFeeModal(true); setSectionID("")}}>
                  + New Fee
                </Button>
              </Container>  
          </Col>
      </Row>
      <ColoredLine color="#DEDEDE" />
      <Row className="row-level-1">
      <h5 className="filter-headers">Department</h5>
      <Col sm={7} lg={8} xs={7}>
          <div className="reactSelect" >
            <Select
                closeMenuOnSelect={true}
                components={animatedComponents}
                value={ {label: chosenDepartment }}
                options={designatedDepartments}
                onChange={(e) => {setChosenDepartment(e.value); SetSelectedDepartment(e.value)}}
            />
          </div>  
      </Col>
    
      </Row> 

      <Row className="row-level-2">
      <h5 className="filter-headers">Category</h5>
          <Col>
          <ButtonGroup>
              <Button onClick={() => {setChosenCategory("All"); SetSelectedCategory("All")}} className={chosenCategory === "All" && "xl-button"} variant={chosenCategory === "All" ? "secondary" : "outline-secondary"}>All</Button>
              {categories.map(category => {
                  if (category.title === chosenCategory){
                      return <Button onClick={() => {setChosenCategory(category.title) ; SetSelectedCategory(category.title)}} className="xl-button" variant="secondary" >{category.title}</Button>
                  } else {
                      return <Button onClick={() => {setChosenCategory(category.title) ; SetSelectedCategory(category.title)}}variant="outline-secondary" >{category.title}</Button>
                  }         
              })}
          </ButtonGroup>
           </Col>
      </Row>

      <Row>

        <Col sm={8} xs={9}>
          <h5 className="filter-headers">Search</h5>
          <Form.Control
            onChange={(e) => setSearchText(e.target.value)}
            className="mb-3"
            type="text"
            placeholder="Search name, description or tags..."
          />
        </Col>
        {permission &&
        <Col sm={4} xs={3} className="update-toggle">
          <h5 className="update-text">Update</h5>
          <Switch 
              onChange={() => setUpdate(!update)}
              checked={update}
              onColor="#4990D9"
              onHandleColor="#316DCA"
              handleDiameter={30}
              uncheckedIcon={false}
              checkedIcon={false}
              boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
              activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
              height={20}
              width={48}
              className="react-switch"
              id="material-switch"
          />
        </Col>
      }
      </Row>

      <SectionsTable sections={sectionsVisible} update={update} setSectionID={setSectionID} setOpenNewModal={setOpenNewModal} chosenDepartment={chosenDepartment}/>

      {openNewModal && (
        <SectionModel
          openNewModal={openNewModal}
          setOpenNewModal={setOpenNewModal}
          setSectionCreated={setSectionCreated}
          setSectionUpdated={setSectionUpdated}
          setSectionError={setSectionError}
          getSections={getSections}
          setSections={setSections}
          sectionID={sectionID}
          sections={sections}
          chosenDepartment={chosenDepartment}
          categories={categories}
          chosenCategory={chosenCategory}
          tags={tags}
        />
      )}

      {openFeeModal && (
        <FeeModal
          openFeeModal={openFeeModal}
          setOpenFeeModal={setOpenFeeModal}
          department={chosenDepartment}
        />
        )        
      }
    </Container>
  );
};

export default Sections;
